import styled from 'styled-components';

import Button from '../../../../../components/Button/Button';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 50px;
`;

const SelectContainer = styled.div`
  margin: 20px 0 10px;
`;

const StyledButton = styled(Button)`
  height: 40px;
  font-size: 14px;
  border-radius: 5px;
`;

export {
  ModalContent,
  SelectContainer,
  StyledButton,
};
